import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useEffect } from 'react';
import MeetingController from './MeetingController';
import PreviewMeeting from './PreviewMeeting';
import { useBackgroundAppContext, usePostBackgroundMessage, } from '../../iframe/useBackgroundApp';
import { ProxyMessages } from '../../iframe/integratedMessages';
import LoadingBlock from '../Common/LoadingBlock';
import EmbedderContainer from '../Common/EmbedderContainer';
function MeetingEdit({ attributes: { url }, isSelected, setAttributes, preview = true, origin = 'gutenberg', fullSiteEditor, }) {
    const isBackgroundAppReady = useBackgroundAppContext();
    const monitorFormPreviewRender = usePostBackgroundMessage();
    const handleChange = (newUrl) => {
        setAttributes({
            url: newUrl,
        });
    };
    useEffect(() => {
        monitorFormPreviewRender({
            key: ProxyMessages.TrackMeetingPreviewRender,
            payload: {
                origin,
            },
        });
    }, [origin]);
    return !isBackgroundAppReady ? (_jsx(LoadingBlock, {})) : (_jsxs(Fragment, { children: [(isSelected || !url) && (_jsx(MeetingController, { url: url, handleChange: handleChange })), preview && url && (_jsx(PreviewMeeting, { url: url, fullSiteEditor: fullSiteEditor }))] }));
}
export default function MeetingsEditContainer(props) {
    return (_jsx(EmbedderContainer, { children: _jsx(MeetingEdit, { ...props }) }));
}
